import { CHCLoginBanner } from './login-banner.component.js';
export { CHCLoginBanner };

customElements.define('chcapp-login-banner', CHCLoginBanner);

declare global {
  interface HTMLElementTagNameMap {
    'chcapp-login-banner': CHCLoginBanner;
  }
}
